// RAMDA
import { 
  equals, 
  isEmpty, 
  reject, 
} from 'ramda'

export const doesSuccessfullyCallTheApi = (inputStatus) => {
  const successRegex = /^20[0-9]$/
  return successRegex.test(inputStatus)
}

export const isEmailFormatValid = (inputEmail) => {
  const format = /\S+@\S+\.\S+/
  return format.test(inputEmail)
}

export const isObjectEmpty = (inputObject) => {
  return isEmpty(reject(equals(null), inputObject))
}

export const isPasswordFormatValid = (inputPassword) => {
  return inputPassword.length < 8 ? false : true
}
